var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{attrs:{"id":"form","method":"POST"},on:{"submit":_vm.submitForm}},[_c('FormItems',{attrs:{"formItems":_vm.formItems,"data":this.case.data,"disabled":_vm.disabled},on:{"change":_vm.onChange}}),(_vm.showSubmitButton)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","disabled":_vm.loading}},[_vm._v("Opslaan")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }